module.exports = __webpack_public_path__ + "static/media/1_shar_big_83.13_66.57.1ba77f35.png";